const { Rollbar, dataLayer } = window as any;

export const track = (payload: { eventLabel: string; eventAction: string }) =>
  dataLayer
    ? dataLayer.push({ ...payload, event: 'b2b', eventCategory: 'b2b' })
    : Rollbar && Rollbar.error('GTM not loaded');
